<template>
    <!-- Start Main Banner -->
    <div class="main-banner">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="row h-100 justify-content-center align-items-center">
                        <div class="col-lg-5">
                            <div class="hero-content">
                                <h1>Educating the Guess</h1>
                                <p>Founders, investors and managers often rely on a combination of intuition and experience to form their assumptions: Educated Guesses. Start educating your guess today and get valuable insights about your own business model assumptions.</p>
                                
                                <!--<a href="#" class="btn btn-primary">Get Started</a>-->
                            </div>
                        </div>

                        <div class="col-lg-5 offset-lg-1">
                            <div class="banner-form ml-3" id="app">
                                <form prefix="formElement" ref="form">
                                    
                                    <div class="form-group">
                                        <label>Name</label>
                                        <input type="text" class="form-control" placeholder="Enter your name" v-model="name" required>
                                    </div>

                                    <div class="form-group">
                                        <label>Email</label>
                                        <input type="email" class="form-control" placeholder="Enter your email" v-model="email" required>
                                    </div>

                                    <div class="form-group">
                                        <label>Company</label>
                                        <input type="text" class="form-control" placeholder="Enter your company name" v-model="company">
                                    </div>

                                    <!--<div class="form-group">
                                    <label>Password</label>
                                    <input type="password" class="form-control" placeholder="Create a password">
                                    </div>-->

                                    <button type="button" v-on:click="response" class="btn btn-primary">Get started</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="shape1"><img src="../../../assets/img/shape1.png" alt="shape"></div>
        <div class="shape2 rotateme"><img src="../../../assets/img/shape2.svg" alt="shape"></div>
        <div class="shape3"><img src="../../../assets/img/shape3.svg" alt="shape"></div>
        <div class="shape4"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
        <div class="shape5"><img src="../../../assets/img/shape5.png" alt="shape"></div>
        <div class="shape6 rotateme"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
        <div class="shape7"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
        <div class="shape8 rotateme"><img src="../../../assets/img/shape2.svg" alt="shape"></div>
    </div>
    <!-- End Main Banner -->
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'Banner',
        data() {
            return {
                name: "", 
                email: "",
                company: "",
            };
        },
        methods: {
            response() {
                console.log("clicked");
                if (this.$refs.form.checkValidity() === false) {
                    alert("Ckeck again, whether you've submitted your name and correct email address.");
                    return;
                }
                var url = 'https://educating-the-guess.com/sendData.php'
                axios.post(url, { name: this.name, email: this.email, company: this.company
                }).then( (response) => {
                    console.log(response)
                    this.$router.push({ name: "success" });

                }).catch(console.error);
            }
        },
    }
</script>